// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1zwmP","title":"FrontImage_title__2R-lh"};